<script>
import PageHeader from "@/components/page-header.vue";
import Layout from "@/views/layouts/main.vue";
import axios from "axios";
import { MenuPath, StorePath } from "@/path";
import Swal from "sweetalert2";
import Add from "@/views/pages/Dilfoods/menu/add.vue";
import Items from "@/views/pages/Dilfoods/menu/items.vue";
import Brands from "@/views/pages/Dilfoods/menu/brands.vue";
import Locations from "@/views/pages/Dilfoods/menu/locations.vue";
import UploadIcon from "@/views/pages/Dilfoods/Common/icons/UploadIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";

export default {
  computed: {
    MenuPath() {
      return MenuPath;
    },
    StorePath() {
      return StorePath;
    },
  },
  components: {
    Locations,
    Brands,
    Items,
    Add,
    PageHeader,
    Layout,
    UploadIcon,
    DeleteIcon,
  },
  data() {
    return {
      title: "Menu",
      headerItems: [
        {
          text: "List",
        },
        {
          text: "menu",
          active: true,
        },
      ],
      filter: [],
      selectedStore: null,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      menu_items: [],
      search_items: [],
      search_stores: [],
      form: {},
      fields: [
        "name",
        "description",
        "total_items",
        "brands",
        "locations",
        "push_to_urban_piper",
        "actions",
      ],
      search_items_api: MenuPath.SEARCH_ITEMS,
      search: "",
      selected_menu: "",
      selectedBrand: "",
      trashed: false,
      current_page: 1,
    };
  },
  mounted() {
    this.getMenuItems();
  },
  watch: {
    search() {
      this.getMenuItems();
    },
    trashed() {
      this.getMenuItems();
    },
    current_page() {
      this.getMenuItems();
    },
  },
  methods: {
    update() {
      this.getMenuItems();
    },
    selectedMenu(v) {
      this.selected_menu = v;
      this.$bvModal.show("add-items");
    },
    selectedBrandMenu(v) {
      this.selected_menu = v;
      this.$bvModal.show("add-brands");
    },
    selectedLocation(v) {
      this.selected_menu = v;
      this.$bvModal.show("add-locations");
    },
    async pushToUp(menu) {
      try {
        let res = await axios.post(this.baseUrl + MenuPath.MENU_PUSH_UP, {
          menu_id: menu.id,
        });
        if (res.data.status) {
          Swal.fire("Saved!", "", "success");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveItem() {
      try {
        let res = await axios.post(
          this.baseUrl + MenuPath.STORE_MENU,
          this.form
        );
        if (res.data.status) {
          Swal.fire("Saved!", "", "success");
          this.getMenuItems();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async deleteItem(v) {
      try {
        let res = await axios.delete(
          this.baseUrl + MenuPath.DELETE_MENU + "/" + v.id
        );
        if (res.data.status) {
          if (this.trashed == true) {
            Swal.fire("Restored", "", "success");
          } else {
            Swal.fire("Deleted", "", "success");
          }
          this.getMenuItems();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addMenu() {
      this.$bvModal.show("add-modal");
    },
    async attachBrand() {
      try {
        if (this.selectedBrand) {
          let res = await axios.post(this.baseUrl + MenuPath.SAVE_BRAND_MENU, {
            brand_id: this.selectedBrand,
            id: this.selected_menu.id,
          });
          if (res.data.status) {
            Swal.fire("success", "", "success");
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getMenuItems() {
      try {
        let res = await axios.get(this.baseUrl + MenuPath.GetMenu, {
          params: {
            search: this.search,
            trash: this.trashed,
            page: this.current_page,
          },
        });
        if (res.data.status) {
          this.menu_items = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <div class="row">
      <div class="col-12">
        <b-button variant="primary" @click="addMenu">Add Menu</b-button>
        <div class="float-right">
          <label>Trashed</label>
          <b-checkbox switch v-model="trashed"></b-checkbox>
        </div>
        <b-modal hide-footer id="add-modal">
          <add @reload="update()"></add>
        </b-modal>
        <b-modal hide-footer size="xl" id="add-items">
          <items :selectedMenu="selected_menu"></items>
        </b-modal>
        <b-modal hide-footer size="xl" id="add-brands">
          <brands :selectedMenu="selected_menu"></brands>
        </b-modal>
        <b-modal hide-footer size="xl" id="add-locations">
          <locations :selectedMenu="selected_menu"></locations>
        </b-modal>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive mb-0">
              <div class="pb-2 float-right w-25">
                <b-row>
                  <b-col sm="12">
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-input
                        size="sm"
                        placeholder="Search"
                        debounce="300"
                        v-model="search"
                      ></b-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>
              <b-table
                :key="menu_items.key"
                :items="menu_items.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(total_items)="row">
                  <div class="d-flex">
                    <p class="pr-4">{{ row.item.menu_items_count }}</p>
                    <b-button
                      variant="secondary"
                      @click="selectedMenu(row.item)"
                      size="sm"
                      ><i class="fa fa-pen"></i
                    ></b-button>
                  </div>
                </template>
                <template v-slot:cell(brands)="row">
                  <div class="d-flex">
                    <b-tag
                      variant="primary"
                      v-for="(b, bk) in row.item.brand_menu"
                      :key="bk"
                      >{{ b.brand.name }}</b-tag
                    >
                    <b-button
                      variant="secondary"
                      @click="selectedBrandMenu(row.item)"
                      size="sm"
                      ><i class="fa fa-pen"></i
                    ></b-button>
                  </div>
                </template>
                <template v-slot:cell(locations)="row">
                  <div>
                    <p>
                      No. of locations :<b>{{ row.item.menu_stores_count }}</b>
                    </p>
                    <b-button
                      variant="secondary"
                      @click="selectedLocation(row.item)"
                      size="sm"
                    >
                      <i class="fa fa-list"></i>
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(push_to_urban_piper)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="pushToUp(row.item)">
                      <UploadIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div
                      v-if="row.item.deleted_at == null"
                      @click="deleteItem(row.item)"
                    >
                      <DeleteIcon variant="danger" />
                    </div>
                    <div v-else @click="deleteItem(row.item)">
                      <DeleteIcon variant="primary" />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="menu_items.key"
                      v-model="current_page"
                      :total-rows="menu_items.total"
                      :per-page="menu_items.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style></style>
